const initialState = {
  jobDataList: {},
  jobDataDetail: {},
  cycleList: {}
}

const admin = (state = initialState, action) => {
  switch (action.type) {
    case "SET_TARGET_GROUP":
      state.listTargetGroup = action.payload;
      return state;
    case "SET_GOAL_LIBRARY_ITEM":
      state.listGoalLibraryGoalItem = action.payload;
      return state;
    case "SET_GOAL_LIBRARY_GROUP":
      state.listGoalGroup = action.payload;
      return state;
    case "SET_GOAL_SUB_GROUP":
      state.listGoalSubGroup = action.payload;
      return state;
    case "SET_DELETE_GOAL_SUB_GROUP":
      state.delItem = action.payload;
      return state;
    case "SET_DELECT_PROGRESS":
      state.delItem = action.payload;
      return state;
    case "SET_DELETE_CATEGORY":
      state.delItem = action.payload;
      return state;
    case "SET_DELETE_GOAL_LIBRARY":
      state.delItem = action.payload;
      return state;
    case "SET_GOAL_PROGRESS":
      state.listGoalProgress = action.payload;
      return state;
    case "SET_DELETE_PROGRESS_GROUP":
      state.delProgressGroup = action.payload;
      return state;
    case "SET_GOAL_PROGRESS_GROUP":
      state.listGoalProgressGroup = action.payload;
      return state;
    case "SET_GOAL_CATEGORY":
      state.listGoalCategory = action.payload;
      return state;
    case "SET_EVALUATE_TYPE":
      state.listEvaluateType = action.payload;
      return state;
    case "SET_JOB_DATA_LIST":
      state.jobDataList = action.payload;
      return state;
    case "SET_JOB_DATA_DETAIL":
      state.jobDataDetail = action.payload;
      return state;
    case "SET_CYCLE_LIST":
      state.cycleList = action.payload;
      return state;
    case "SET_POSITION_LIST":
      state.positionList = action.payload;
      return state;
    case "SET_POSITION_DETAIL":
      state.positionDetail = action.payload;
      return state;
    case "SET_CURRENT_EMPLOYEES":
      state.currentEmployees = action.payload;
      return state;
    case "SET_GOAL_LIBRARY":
      state.listGoalLibrary = action.payload;
      return state;
    default:
      return state;
  }
};

export default admin;
